import { useCallback } from 'react';

import style from './index.style';

function ButtonGroup({ className, tabs, selectedItem, setSelectedItem }) {
  const handleSelectItem = useCallback(
    (id) => {
      setSelectedItem(id);
    },
    [setSelectedItem]
  );
  return (
    <div className={`button-group-container ${className} relative`}>
      {tabs?.map((item) => (
        <div
          onClick={() => handleSelectItem(item?.id)}
          key={item?.id}
          className={`button-group-item d-f fd-c  ${
            item?.id === selectedItem && 'selected-button-group-item'
          }`}
        >
          <span
            className={`button-group-label ${
              item?.id === selectedItem && 'selected-button-group-label'
            }`} 
          >
            {item?.label}
          </span>
        </div>
      ))}
      <style jsx>{style}</style>
    </div>
  );
}

export default ButtonGroup;
